import { useMemo } from 'react';
import { useAppSelector } from '@store/hooks';
import {
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
  hasDeveloperAccess,
} from '@utils/permissions';

export function usePermission() {
  const user = useAppSelector((state) => state.auth.user);

  return useMemo(
    () => ({
      can: (permission: string) => hasPermission(user, permission),
      canAny: (permissions: string[]) => hasAnyPermission(user, permissions),
      canAll: (permissions: string[]) => hasAllPermissions(user, permissions),
      /** Explicit Developer tools grant — not implied by the admin role. */
      isDeveloper: hasDeveloperAccess(user),
      user,
    }),
    [user],
  );
}
